import { ToastService } from "@shared/lib/services";
import { IGetPayoutsRequest } from "@shared/lib/types/briefCampains";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { PAYOUTS_FACETS_QUERY_KEY } from "../contsants";
import { CampaignService } from "../services/Campaign.service";

export function useGetPayoutFacets(
  params: Omit<IGetPayoutsRequest, "briefIds">
) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: [...PAYOUTS_FACETS_QUERY_KEY(), params],
    queryFn: () => CampaignService.getVendorPaoutsFacets(params),
  });

  const errorMessage = isError && error?.message;

  useEffect(() => {
    if (errorMessage) {
      ToastService.error(errorMessage);
    }
  }, [errorMessage]);

  return {
    facets: data?.data,
    isLoading,
    isError,
  };
}
